import React, { useEffect, useState } from "react";
import VideoJS from "./VideoJS";
import { getAnalytics, logEvent } from "firebase/analytics";
import { useEnv } from "../context/env.context";
import { RootState } from "../store";
import { useSelector } from "react-redux";

interface VideoProps {
    source: string,
    type_title: string,
    poster?: string,
    assessment?: string,
    played_from?: string,
    captions?: {
        src: string,
        srclang?: string,
        label: string,
        kind?: 'subtitles' | 'captions' | 'descriptions' | 'chapters' | 'metadata'
    } | string
}

export const VideoPlayerWithAnalytics: React.FC<VideoProps> = ({
    source, type_title, poster, assessment, played_from, captions
}) => {
    const { domain } = useEnv();
    const playerRef = React.useRef(null);
    const { userIdForAnalytics } = useSelector((state: RootState) => state.user);

    const handlePlayerReady = (player) => {
        playerRef.current = player;

        player.on('play', () => {
                logEvent(getAnalytics(), `[EVENT] ${type_title} Video`, {
                    "assessment_title": assessment,
                    "launched_from": played_from,
                    "gc_analytics_id": userIdForAnalytics
                })
        }); 
    };

    return (
        <VideoJS 
            poster={poster ?? "https://public-assets.ccl.org/images/icons/ccl/android-chrome-512x512.png"} 
            source={source}
            captions={captions}
            onReady={handlePlayerReady}
        />
    );
}